import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  politicsAndProceduresLength: 0,
  politicsAndProcedures: [],
  politicsAndProcedure: {},
  politicsAndProcedureError: "",
  formError: "",
  formErrorJson: {},
};

export default function PoliticsAndProceduresReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_POLITICS_AND_PROCEDURES:
      return { ...state, loading: action.payload };
    case actions.LOADING_POLITICS_AND_PROCEDURES_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_POLITICS_AND_PROCEDURES:
      return { ...state, saveLoading: action.payload };
    case actions.GET_POLITICS_AND_PROCEDURES:
      return {
        ...state,
        politicsAndProcedures: action.payload.politicsAndProcedures,
        politicsAndProceduresLength: action.payload.politicsAndProceduresLength,
      };
    case actions.GET_POLITICS_AND_PROCEDURES_BY_ID:
      return {
        ...state, politicsAndProcedure: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FORM_FAIL_JSON:
      return { ...state, formErrorJson: action.payload };
    case actions.POLITICS_AND_PROCEDURES_FAIL:
      return { ...state, politicsAndProcedureError: action.payload };
    default:
      return state;
  }
}
